import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import './index.css';

import { auth } from './lib/firebase.ts';

// Safely intercept fetch to attach auth token when possible without breaking environments with read-only window.fetch
try {
  if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
    const originalFetch = window.fetch.bind(window);
    const customFetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
      const url = args[0];
      const options = (args[1] || {}) as RequestInit;
      
      if (typeof url === 'string' && url.startsWith('/api/')) {
        try {
          if (auth && auth.currentUser) {
            const token = await auth.currentUser.getIdToken();
            const headers = new Headers(options.headers || {});
            if (!headers.has('Authorization')) {
              headers.set('Authorization', `Bearer ${token}`);
            }
            options.headers = headers;
          }
        } catch (e) {
          console.warn('Could not inject auth token', e);
        }
      }
      
      return originalFetch(url, options);
    };

    try {
      Object.defineProperty(window, 'fetch', {
        value: customFetch,
        writable: true,
        configurable: true,
      });
    } catch {
      try {
        // @ts-ignore
        window.fetch = customFetch;
      } catch {
        // Safe fallback in restricted sandboxes where window.fetch cannot be mutated
      }
    }
  }
} catch {
  // Never let fetch patching block application bootstrap
}


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
